import { useEffect, useRef } from 'react'

export default function usePropChangeEffect<PropType = unknown>(
  currentValue: PropType,
  effect: (value: PropType, lastValue: PropType) => void | (() => void)
) {
  const hookStateRef = useRef<{ last: PropType; effect: typeof effect }>()
  if (!hookStateRef.current) {
    hookStateRef.current = { last: currentValue, effect }
  }
  hookStateRef.current.effect = effect

  useEffect(() => {
    if (hookStateRef.current.last !== currentValue) {
      const lastValue = hookStateRef.current.last
      hookStateRef.current.last = currentValue
      return hookStateRef.current.effect(currentValue, lastValue)
    }
    return void 0
  }, [currentValue])
}
